@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.messageWrapper {
  display: flex;
  border: 1px solid variables.$orange-base;
  border-radius: 8px;
  padding: variables.$std-padding-sm;
  align-items: center;
}

.messageIcon {
  font-size: 35px;
  margin-right: variables.$std-margin-xs;
}

.messageText {
  font-size: 13px;
}
